// Dados centrais do site — Desentupidora Paulistana
const IMG = "https://static.prod-images.emergentagent.com/jobs/6f07a0aa-46c1-4336-afdd-d5ce58abd09f/images";

export const COMPANY = {
  name: "Desentupidora Paulistana",
  cnpj: "08.133.326/8321-70",
  address: "R. Maestro Elias Lobo, 1003 — São Paulo / SP",
  cep: "01448-010",
  phoneDisplay: "(11) 97195-0197",
  phoneTel: "011971950197",
  whatsapp: "5511971950197",
  site: "https://desentupidorapaulistana.site",
  hours: "24 horas por dia, 7 dias por semana (incluindo feriados)",
  yearsExperience: "15",
  email: "contato@desentupidorapaulistana.site",
};

export const waLink = (msg) =>
  `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    msg || "Olá! Preciso de uma desentupidora 24h. Pode me ajudar?"
  )}`;

export const pageUrl = (path) => {
  if (path === "/" || !path) return "/";
  return path.endsWith(".html") ? path : `${path}.html`;
};

export const serviceUrl = (slug) => `/servicos/${slug}.html`;
export const bairroUrl = (slug) => `/bairros/desentupidora-${slug}.html`;
export const blogUrl = (slug) => `/blog/${slug}.html`;
export const SERVICE_BAIRRO_SLUGS = [
  "jardim-america",
  "jardim-europa",
  "jardim-paulista",
  "jardim-paulistano",
  "itaim-bibi",
  "vila-nova-conceicao",
  "vila-olimpia",
  "brooklin-novo",
  "moema",
  "vila-mariana",
];
export const serviceBairroUrl = (serviceSlug, bairroSlug) =>
  SERVICE_BAIRRO_SLUGS.includes(bairroSlug)
    ? `/servico-bairro/${serviceSlug}-${bairroSlug}.html`
    : serviceUrl(serviceSlug);

export const heroImage = `${IMG}/2f886fced22f9e1c830ebccdfc13ba2c4094c89a834103a3039c3ca03cefd316.png`;
export const bairrosImage = `${IMG}/3b5ab612270669a3fad5d499cf5d470dbe29034b02013a4630b464993bab73f3.png`;

export const SERVICES = [
  {
    slug: "desentupimento-de-pia",
    name: "Desentupimento de Pia",
    label: "Residencial",
    image: `${IMG}/af51ef10f259b87764c1401b1ad0b1ec261f1193cb8e1924aa040a6a016cf1e0.png`,
    short: "Pia da cozinha ou banheiro entupida? Resolvemos com rapidez, sem sujeira e sem quebra-quebra.",
    intro:
      "Pia entupida atrapalha a rotina e pode gerar mau cheiro e refluxo de água suja. Nossa equipe atua em toda a capital com equipamentos modernos para liberar a tubulação sem danificar o acabamento.",
    benefits: [
      "Atendimento de emergência em até 15 minutos nos bairros nobres",
      "Equipamento profissional sem quebra de azulejos",
      "Garantia do serviço executado",
      "Orçamento transparente antes de iniciar",
    ],
    faq: [
      { q: "Quanto custa desentupir uma pia?", a: "O valor depende do nível do entupimento e da metragem da tubulação. Fazemos a avaliação no local e informamos o orçamento antes de iniciar — sem surpresas." },
      { q: "Vocês quebram a parede para desentupir?", a: "Não. Usamos máquinas rotativas e hidrojateamento que liberam o cano sem quebra-quebra na grande maioria dos casos." },
      { q: "Em quanto tempo chegam?", a: "Nos bairros nobres de São Paulo, nossa média de chegada é de 15 a 30 minutos." },
    ],
  },
  {
    slug: "desentupimento-de-vaso-sanitario",
    name: "Desentupimento de Vaso Sanitário",
    label: "Residencial",
    image: `${IMG}/faaf6ff3064214fcdc583a865e092339579e30dd3003d7974e2038cebdd706df.png`,
    short: "Vaso sanitário entupido é urgência. Atendemos 24h com discrição e higiene total.",
    intro:
      "Um vaso sanitário entupido precisa de solução imediata. Atendemos residências e condomínios com total higiene, equipamentos próprios e profissionais uniformizados.",
    benefits: [
      "Atendimento 24h, todos os dias",
      "Profissionais uniformizados e discretos",
      "Higiene total durante e após o serviço",
      "Sem danos à louça sanitária",
    ],
    faq: [
      { q: "Posso usar produto químico antes de chamar?", a: "Evite produtos corrosivos: eles podem danificar a tubulação e dificultar o serviço. O ideal é acionar a desentupidora diretamente." },
      { q: "O serviço é higiênico?", a: "Sim. Trabalhamos com equipamentos de proteção, lonas e produtos de higienização, deixando o ambiente limpo ao final." },
    ],
  },
  {
    slug: "desentupimento-de-esgoto",
    name: "Desentupimento de Esgoto",
    label: "Emergencial",
    image: `${IMG}/7f42494ea8b962787695bfedb12324a2d5d93c3d7c86c4eb0e1c6f9e14dfb100.png`,
    short: "Refluxo de esgoto e mau cheiro? Desobstruímos colunas e ramais com tecnologia profissional.",
    intro:
      "Entupimentos de esgoto causam refluxo, mau cheiro e risco à saúde. Atuamos em residências, prédios e empresas com máquinas rotativas e hidrojateamento de alta pressão.",
    benefits: [
      "Desobstrução de ramais e colunas",
      "Eliminação de mau cheiro e refluxo",
      "Atendimento a condomínios e empresas",
      "Equipamentos de alta pressão",
    ],
    faq: [
      { q: "Atendem prédios e condomínios?", a: "Sim. Temos experiência com colunas de esgoto de edifícios, com equipamentos adequados para tubulações verticais." },
      { q: "O serviço resolve o mau cheiro?", a: "Sim. Ao desobstruir e higienizar a tubulação, o mau cheiro causado pelo acúmulo é eliminado." },
    ],
  },
  {
    slug: "hidrojateamento",
    name: "Hidrojateamento",
    label: "Comercial",
    image: `${IMG}/b674b5a40e49b818e9a12fbcb30c2bf4448a3cd9e4cc2a858058b607cab318a6.png`,
    short: "Limpeza profunda de tubulações com jato de água de alta pressão. Ideal para casos graves.",
    intro:
      "O hidrojateamento utiliza água em alta pressão para remover gordura, raízes e incrustações que máquinas comuns não alcançam. É a solução definitiva para tubulações de grande porte e casos recorrentes.",
    benefits: [
      "Remove gordura, raízes e incrustações",
      "Indicado para tubulações industriais e comerciais",
      "Limpeza profunda e duradoura",
      "Previne entupimentos recorrentes",
    ],
    faq: [
      { q: "Quando o hidrojateamento é indicado?", a: "Em tubulações com acúmulo de gordura, raízes, ou entupimentos que voltam com frequência. Também na manutenção preventiva de restaurantes e indústrias." },
      { q: "O jato danifica o cano?", a: "Não. A pressão é regulada conforme o tipo e diâmetro da tubulação, garantindo limpeza sem danos." },
    ],
  },
  {
    slug: "limpeza-de-caixa-de-gordura",
    name: "Limpeza de Caixa de Gordura",
    label: "Comercial",
    image: `${IMG}/cad3c18db15687bd671864fafe7386f088994fe9d37d5f6361ddf8be56e539e1.png`,
    short: "Manutenção de caixas de gordura para restaurantes, cozinhas e condomínios. Sem odores.",
    intro:
      "A limpeza periódica da caixa de gordura evita entupimentos, mau cheiro e problemas com a fiscalização. Atendemos restaurantes, cozinhas industriais e condomínios com sucção e descarte correto.",
    benefits: [
      "Sucção e descarte ambientalmente correto",
      "Elimina mau cheiro e moscas",
      "Evita entupimentos da cozinha",
      "Contratos de manutenção preventiva",
    ],
    faq: [
      { q: "Com que frequência limpar a caixa de gordura?", a: "Em estabelecimentos comerciais, recomenda-se limpeza mensal ou conforme o volume. Em residências, a cada 3 a 6 meses." },
      { q: "Vocês dão o comprovante de descarte?", a: "Sim. O descarte é feito de forma ambientalmente correta, com comprovação quando necessário." },
    ],
  },
  {
    slug: "desentupimento-de-ralo",
    name: "Desentupimento de Ralos e Calhas",
    label: "Emergencial",
    image: `${IMG}/9392056a9f06f29ed054ba234b4049d210ee290e62c99c7b3d66a1cc73d711f0.png`,
    short: "Ralos, calhas e caixas de inspeção entupidas? Desobstruímos para evitar alagamentos.",
    intro:
      "Ralos e calhas entupidos provocam alagamentos e infiltrações, principalmente em períodos de chuva. Desobstruímos caixas de inspeção, ralos e tubulações de águas pluviais com agilidade.",
    benefits: [
      "Previne alagamentos e infiltrações",
      "Desobstrução de águas pluviais",
      "Atendimento rápido em emergências",
      "Inspeção das caixas e ralos",
    ],
    faq: [
      { q: "Atendem em dias de chuva?", a: "Sim. Justamente nos dias de chuva os ralos e calhas entopem mais. Mantemos plantão 24h para emergências." },
      { q: "Fazem inspeção das caixas?", a: "Sim. Inspecionamos as caixas de passagem para identificar a origem do entupimento." },
    ],
  },
];

export const BAIRROS = [
  { slug: "jardim-america", name: "Jardim América", region: "Jardins", cep: "01408" },
  { slug: "jardim-europa", name: "Jardim Europa", region: "Jardins", cep: "01449" },
  { slug: "jardim-paulista", name: "Jardim Paulista", region: "Jardins", cep: "01401" },
  { slug: "jardim-paulistano", name: "Jardim Paulistano", region: "Jardins", cep: "01451" },
  { slug: "itaim-bibi", name: "Itaim Bibi", region: "Zona Oeste", cep: "04534" },
  { slug: "vila-nova-conceicao", name: "Vila Nova Conceição", region: "Zona Sul", cep: "04512" },
  { slug: "vila-olimpia", name: "Vila Olímpia", region: "Zona Sul", cep: "04547" },
  { slug: "brooklin-novo", name: "Brooklin Novo", region: "Zona Sul", cep: "04571" },
  { slug: "moema", name: "Moema", region: "Zona Sul", cep: "04077" },
  { slug: "vila-mariana", name: "Vila Mariana", region: "Zona Sul", cep: "04116" },
  { slug: "campo-belo", name: "Campo Belo", region: "Zona Sul", cep: "04609" },
  { slug: "morumbi", name: "Morumbi", region: "Zona Oeste", cep: "05650" },
  { slug: "pinheiros", name: "Pinheiros", region: "Zona Oeste", cep: "05422" },
  { slug: "alto-de-pinheiros", name: "Alto de Pinheiros", region: "Zona Oeste", cep: "05461" },
  { slug: "vila-madalena", name: "Vila Madalena", region: "Zona Oeste", cep: "05433" },
  { slug: "perdizes", name: "Perdizes", region: "Zona Oeste", cep: "05014" },
  { slug: "sumare", name: "Sumaré", region: "Zona Oeste", cep: "01255" },
  { slug: "higienopolis", name: "Higienópolis", region: "Centro-Oeste", cep: "01241" },
  { slug: "cerqueira-cesar", name: "Cerqueira César", region: "Centro", cep: "01401" },
  { slug: "pacaembu", name: "Pacaembu", region: "Centro-Oeste", cep: "01234" },
];

export const TESTIMONIALS = [
  { name: "Marina Aguiar", bairro: "Jardins", text: "Chegaram em 20 minutos num domingo à noite. Resolveram o entupimento da pia sem sujeira nenhuma. Recomendo demais!", rating: 5 },
  { name: "Ricardo Tavares", bairro: "Itaim Bibi", text: "Atendimento impecável no nosso prédio. Profissionais educados e equipamento de primeira. Esgoto liberado rapidamente.", rating: 5 },
  { name: "Camila Bueno", bairro: "Moema", text: "Restaurante salvo! Fazem a manutenção da nossa caixa de gordura e nunca mais tivemos problema. Empresa séria.", rating: 5 },
  { name: "Eduardo Lima", bairro: "Higienópolis", text: "Preço justo e transparente. Passaram o orçamento antes e cumpriram tudo. Vaso sanitário desentupido em minutos.", rating: 5 },
];

export const BLOG = [
  {
    slug: "quanto-custa-hidrojateamento-jardins",
    title: "Quanto custa o hidrojateamento nos Jardins em 2026?",
    excerpt: "Entenda o que influencia o preço do hidrojateamento e por que é o melhor investimento para tubulações dos bairros nobres.",
    image: `${IMG}/b674b5a40e49b818e9a12fbcb30c2bf4448a3cd9e4cc2a858058b607cab318a6.png`,
    date: "2026-05-12",
    category: "Preços",
    content: [
      "O hidrojateamento é uma das técnicas mais eficientes para a limpeza profunda de tubulações. Mas, afinal, quanto custa esse serviço nos Jardins e demais bairros nobres de São Paulo?",
      "O valor varia conforme o diâmetro e a extensão da tubulação, o grau de obstrução e a acessibilidade do local. Tubulações com acúmulo de gordura ou raízes exigem mais tempo de máquina, o que pode influenciar o orçamento.",
      "Na Desentupidora Paulistana, sempre fazemos uma avaliação técnica gratuita antes de iniciar. Você recebe um orçamento transparente, sem surpresas, e só autoriza o serviço se concordar com o valor.",
      "Vale lembrar: o hidrojateamento é um investimento. Ele remove o que máquinas comuns não alcançam, prevenindo entupimentos recorrentes e economizando dinheiro a longo prazo.",
    ],
  },
  {
    slug: "como-evitar-entupimento-de-pia",
    title: "Como evitar o entupimento da pia: 7 dicas práticas",
    excerpt: "Pequenos hábitos no dia a dia evitam dores de cabeça. Veja como manter a pia da cozinha sempre livre.",
    image: `${IMG}/af51ef10f259b87764c1401b1ad0b1ec261f1193cb8e1924aa040a6a016cf1e0.png`,
    date: "2026-04-28",
    category: "Prevenção",
    content: [
      "O entupimento da pia da cozinha é um dos chamados mais frequentes que atendemos. A boa notícia é que ele pode ser evitado com hábitos simples.",
      "1. Nunca jogue óleo ou gordura na pia — guarde em uma garrafa e descarte no lixo. 2. Use uma tela protetora no ralo para reter restos de comida. 3. Despeje água quente periodicamente para dissolver resíduos de gordura.",
      "4. Evite jogar borra de café e cascas. 5. Limpe o sifão a cada poucos meses. 6. Faça manutenção preventiva da caixa de gordura. 7. Ao primeiro sinal de escoamento lento, acione um profissional antes que vire emergência.",
      "Se mesmo assim a pia entupir, conte com a Desentupidora Paulistana 24 horas por dia.",
    ],
  },
  {
    slug: "esgoto-entupido-em-condominio",
    title: "Esgoto entupido em condomínio: de quem é a responsabilidade?",
    excerpt: "Coluna de esgoto entupida afeta vários apartamentos. Entenda como agir e quem deve acionar a desentupidora.",
    image: `${IMG}/7f42494ea8b962787695bfedb12324a2d5d93c3d7c86c4eb0e1c6f9e14dfb100.png`,
    date: "2026-03-15",
    category: "Condomínios",
    content: [
      "Quando o esgoto entope em um condomínio, a primeira dúvida é sempre: quem paga? A resposta depende de onde está o entupimento.",
      "Se o problema está no ramal interno do apartamento, a responsabilidade costuma ser do proprietário. Já entupimentos na coluna ou tubulação coletiva são responsabilidade do condomínio.",
      "O ideal é acionar uma desentupidora especializada em prédios, que identifica a origem com precisão e atua nas colunas verticais com segurança.",
      "A Desentupidora Paulistana atende síndicos e administradoras com agilidade e nota fiscal, mantendo plantão 24h para emergências.",
    ],
  },
  {
    slug: "vaso-sanitario-entupido-o-que-fazer",
    title: "Vaso sanitário entupido: o que fazer (e o que NÃO fazer)",
    excerpt: "Antes de chamar ajuda, evite os erros mais comuns que pioram o entupimento do vaso.",
    image: `${IMG}/faaf6ff3064214fcdc583a865e092339579e30dd3003d7974e2038cebdd706df.png`,
    date: "2026-02-20",
    category: "Emergência",
    content: [
      "O vaso sanitário entupido é uma das emergências domésticas mais incômodas. Antes de tudo, mantenha a calma e não dê descargas seguidas — isso só aumenta o risco de transbordamento.",
      "NÃO use objetos pontiagudos para empurrar a obstrução, pois você pode trincar a louça. Evite também produtos químicos corrosivos: eles danificam a tubulação e são perigosos.",
      "Se a água estiver subindo, feche o registro de água do vaso. Em seguida, acione um profissional. O desentupimento com equipamento adequado é rápido e seguro.",
      "A Desentupidora Paulistana atende emergências 24 horas nos bairros nobres de São Paulo, com chegada média de 15 a 30 minutos.",
    ],
  },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Serviços", to: "/servicos.html" },
  { label: "Bairros", to: "/bairros.html" },
  { label: "Sobre", to: "/sobre.html" },
  { label: "Blog", to: "/blog.html" },
  { label: "Contato", to: "/contato.html" },
];
